import SpaceY from '../../../components/SpaceY';

import SourcingFirstSection from './sourcing-philosophy/SourcingFirstSection';
import SourcingLastSection from './sourcing-philosophy/SourcingLastSection';
import SourcingSecondSection from './sourcing-philosophy/SourcingSecondSection';
import SourcingWrapper from './sourcing-philosophy/SourcingWrapper';

const MissionSecondTab = () => {
  return (
    <>
      <div className="mx-auto max-w-screen-lg px-16px">
        <SpaceY height={72} />
        <SourcingFirstSection />

        <SpaceY height={72 + 24} />
        <SourcingSecondSection />

        <SpaceY height={72} />
        <SourcingWrapper
          index={2}
          title={
            <>
              지속가능한 농법이
              <br />
              확산될 수 있도록
            </>
          }
          description="화학 농약, 제초제, 살충제를 사용하지 않는 친환경 인증 농산품의 판로 개척을 우선합니다. 무농약, 유기농 농법으로는 수확량 보전이 어려운 농산물은 제초제, 농약 살포 횟수, 사용 비료 성분이 보다 친환경적인 과정을 통해 재배된 것을 우선합니다."
        />

        <SpaceY height={72} />
        <SourcingWrapper
          index={3}
          title={
            <>
              생산자와 소비자가
              <br />
              서로 지지하며 믿을 수 있도록
            </>
          }
          description={
            <>
              모든 파트너쉽은 현장 방문을 통해 기준에 적합한지 확인하고, 직접
              먹어본 뒤에 이루어집니다. 산지 또한 생산 환경과 과정을 투명하게
              공개하는 것을 원칙으로 합니다.
              <br />
              <br />
              고객의 의견을 산지에 산지의 이야기를 고객에게 전하며 산지는
              개선을, 소비자는 응원을 통해 신뢰의 연결 고리를 만듭니다.
            </>
          }
        />

        <SpaceY height={72} />
      </div>
      <SourcingLastSection />
    </>
  );
};

export default MissionSecondTab;
